import { Rule } from '@leprecoins/effector-forms';

export const greaterZeroRule: Rule<number | string> = {
	name: 'greater-zero',
	validate: (value: number | string) => Number(value) > 0,
};
